import axios from '../config';

const headers = {
   headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
   },
};

export const updateUser = (credentials) => {
   return axios.put(`/user`, credentials, { headers });
};

export const plans = () => {
   return axios.get(`/subscription/plans`, { headers });
};

export const addcard = (token) => {
   return axios.post(`/subscription/stripe/card`, token, { headers });
};

export const couponCheck = (coupon, planid) => {
   return axios.get(`/subscription/plans/coupon/${coupon}?plan_id=${planid}`, { headers });
};

export const subscribe = (data) => {
   return axios.post(`/subscription/`, data, { headers });
};

export const getSub = () => {
   return axios.get(`/subscription/latest`, { headers });
};

export const cancelSub = () => {
   return axios.put(`/subscription/stripe/cancel`, { headers });
};
